// extracted by mini-css-extract-plugin
export default {"input":"AdminReporting_input__hyrck","columnsTable":"AdminReporting_columnsTable__iFPXv"};